module.exports = "<app-header-public></app-header-public>\n<router-outlet></router-outlet>"